import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomSuccessToaster from "./../components/SuccessToaster/CustomSuccessToaster";

export const NotifySuccess = (message) =>
  toast.success(<CustomSuccessToaster successMessage={message} />,{autoClose: 5000,});
